export enum SearchType {
  Text = 'Text',
  SAYT = 'SAYT',
  Interchange = 'Interchange',
  Navigation = 'Parts',
  GFX = 'GFX',
}

// Base search event data
interface BaseSearchEventData {
  search_type: SearchType
  search_term?: string
}

// Navigation and GFX search data
export interface NavigationSearchData extends BaseSearchEventData {
  search_type: SearchType.Navigation | SearchType.GFX
  category?: string
  group?: string
  part_type?: string
}

// All other search types (Text, SAYT, Interchange)
export interface StandardSearchData extends BaseSearchEventData {
  search_type: SearchType.Text | SearchType.SAYT | SearchType.Interchange
  search_term: string
}
